import { useRouteError, Link } from "react-router-dom";

export function ErrorBoundary() {
  const error = useRouteError() as Error;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-text p-4">
      <div className="max-w-md w-full bg-card p-6 rounded-lg shadow-sm border border-border text-center space-y-4">
        <h1 className="text-2xl font-bold text-red-500">Hoppá, valami hiba történt!</h1>
        <p className="opacity-80">
          Nem sikerült betölteni a kért oldalt. Lehet, hogy megszakadt a kapcsolat, vagy hibás
          adatra futottunk.
        </p>
        {error?.message && (
          <div className="bg-background p-2 rounded text-xs text-left font-mono overflow-auto max-h-32 text-red-400">
            {error.message}
          </div>
        )}
        <div className="pt-4">
          <Link
            to="/"
            className="inline-block bg-main text-background font-bold px-6 py-2 rounded-full hover:opacity-90 transition-opacity"
          >
            Vissza a főoldalra
          </Link>
        </div>
      </div>
    </div>
  );
}
